// This file is generated by pnpm icons:generate. Do not edit.

import {createSVG} from '../TEMPLATE'

export const Tote = createSVG({
  elements: [
    {
      fill: 'currentColor',
      stroke: 'none',
      type: 'path',
      d: 'M22.125 6.506A1.5 1.5 0 0 0 20.992 6H16.5a4.5 4.5 0 0 0-9 0H3.008a1.5 1.5 0 0 0-1.125.506 1.5 1.5 0 0 0-.368 1.17l1.337 11.25a1.5 1.5 0 0 0 1.5 1.324h15.305a1.5 1.5 0 0 0 1.5-1.324l1.336-11.25a1.5 1.5 0 0 0-.368-1.17ZM12 3a3 3 0 0 1 3 3H9a3 3 0 0 1 3-3Zm7.665 15.75H4.336L3.007 7.5H7.5v2.25a.75.75 0 0 0 1.5 0V7.5h6v2.25a.75.75 0 0 0 1.5 0V7.5H21Z',
      fillRule: 'evenodd',
    },
  ],
  viewBox: '0 0 24 24',
  glyph: 'Tote',
})
